import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlTodoFieldsFragment = { createdAt: string, descriptionPrimaryLang?: string | null, descriptionSecondaryLang?: string | null, done: boolean, dueDate?: string | null, id: string, identityId?: string | null, updatedAt: string };

export const TodoFieldsFragmentDoc = gql`
    fragment TodoFields on Todo {
  createdAt
  descriptionPrimaryLang
  descriptionSecondaryLang
  done
  dueDate
  id
  identityId
  updatedAt
}
    `;